import { BadgeCheck, Ban, FlaskConical, Package, Ship } from "lucide-react";
import { Eyebrow, Reveal } from "@/components/Reveal";

const FEATURES = [
  { icon: FlaskConical, title: "100% Pure Extraction", text: "Wooden ghani pressing below 45°C keeps enzymes, aroma and micronutrients fully intact." },
  { icon: BadgeCheck, title: "Lab-Certified Batches", text: "Every consignment ships with curcumin, ASTA colour, FFA and moisture reports from accredited labs." },
  { icon: Ship, title: "Global Shipping Logistics", text: "FOB, CIF and CFR terms handled end-to-end — documentation, fumigation and container loading." },
  { icon: Package, title: "Custom Bulk Packaging", text: "From 25 kg PP bales to retail-ready private label bottles, packed to your market's spec." },
  { icon: Ban, title: "Zero Chemical Solvents", text: "No hexane, no refining, no deodorising. What leaves the seed is what reaches your buyer." },
];

export default function WhyUs() {
  return (
    <section id="why-us" data-testid="why-us-section" className="bg-night py-20 md:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <Reveal className="max-w-2xl">
          <Eyebrow dark>Why Tsugiva</Eyebrow>
          <h2 className="mt-3 font-serif text-3xl font-semibold leading-tight text-cream sm:text-4xl lg:text-5xl">
            The export partner serious buyers return to
          </h2>
        </Reveal>
        <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-5">
          {FEATURES.map((f, i) => (
            <Reveal key={f.title} delay={i * 0.08} className="h-full">
              <div
                data-testid={`why-us-card-${f.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="group flex h-full flex-col rounded-2xl border border-cream/10 bg-white/[0.04] p-6 transition-all duration-500 hover:-translate-y-2 hover:border-amberwarm/50 hover:bg-white/[0.07]"
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-gold/15 text-amberwarm transition-colors duration-500 group-hover:bg-gold group-hover:text-night">
                  <f.icon size={22} />
                </span>
                <h3 className="mt-5 font-serif text-lg font-semibold text-cream">{f.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-cream/60">{f.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
